<div [@routeAnimations]="getRouteAnimationData()" *ngIf="usePlaceHolder == false">
    <router-outlet></router-outlet>
</div>

<!-- documentPlaceHolder utilizzato per sostituire il contenuto -->
<ng-template #documentPlaceHolder></ng-template>
